// extracted by mini-css-extract-plugin
export default {"select":"table-menu_select__gidNC","form":"table-menu_form__NLdWP"};